// frontend/src/lib/format.js
// Formatage localisé fr-FR — à utiliser partout pour montants et dates.

const EUR = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const EUR_ROUND = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

/** 3936 -> "3 936,00 €" */
export function formatEuros(value) {
  const n = Number(value);
  return Number.isFinite(n) ? EUR.format(n) : '—';
}

/** 3936 -> "3 936 €" (sans décimales, pour les KPIs) */
export function formatEurosShort(value) {
  const n = Number(value);
  return Number.isFinite(n) ? EUR_ROUND.format(n) : '—';
}

/** "2026-07-09" -> "9 juil. 2026" */
export function formatDateFr(value, opts = { day: 'numeric', month: 'short', year: 'numeric' }) {
  if (!value) return '—';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString('fr-FR', opts);
}

/** "2026-07-09" -> "9 juillet 2026" */
export function formatDateLongFr(value) {
  return formatDateFr(value, { day: 'numeric', month: 'long', year: 'numeric' });
}

/** minutes -> "4h00" / "45 min" */
export function formatDuration(minutes) {
  const m = Number(minutes) || 0;
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  const rest = m % 60;
  return rest === 0 ? `${h}h00` : `${h}h${String(rest).padStart(2, '0')}`;
}
